import { JSON } from '../utils/types'
import Pix from './Pix'

export default class PixAutomatico extends Pix {
  constructor(data: JSON) {
    super(data)
  }
}
